import { BaseService } from "../../BaseService";
import { PatientCareUserCreateRequest } from "../model/PatientCareUserCreateRequest";

class Service extends BaseService {
    public async getClinics(): Promise<any[]> {
        const path = '/patient-care/golden-eye-care/clinics';
        return this.get(path);
    }

    public async checkUUID(uuid: string): Promise<boolean> {
        const path = `/patient-care/golden-eye-care/uuid/${uuid}`;
        return this.get(path);
    }

    public async create(params: any): Promise<any> {
        const path = '/patient-care/golden-eye-care/create';
        return this.post(path, params);
    }

    public async getApplicantsByClinic(clinic_id: string, hash: string): Promise<any> {
        const path = `/patient-care/golden-eye-care/clinic/${clinic_id}/${hash}`;
        return this.get(path);
    }

    public async setClinic(uuid: string, clinicId: number) {
        const path = '/patient-care/golden-eye-care/clinic';
        await this.post(path, {
            uuid,
            clinicId
        });
    }

    public async redeem(params: { code: string, clinicId: number }) {
        const path = '/patient-care/golden-eye-care/redeem';
        await this.post(path, params);
    }
}

export const PatientCareGoldenEyeCareService = new Service();